const Big = require('big.js');
const invoice = require('./invoice');

module.exports = {
	totalPrice: {
		dependentFields: ['returnLines'],
		formulate: ({ returnLines = [] }) =>
			Big(invoice.totalPrice.formulate({ invoiceLines: returnLines }))
				.round(2)
				.toNumber()
	}
};
